import { render, staticRenderFns } from "./survey-detail.component.html?vue&type=template&id=1db610b5&scoped=true&external"
import script from "./survey-detail.component.ts?vue&type=script&lang=ts&external"
export * from "./survey-detail.component.ts?vue&type=script&lang=ts&external"
import style0 from "./survey-detail.component.scss?vue&type=style&index=0&id=1db610b5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db610b5",
  null
  
)

export default component.exports